/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 07981c041395
 */

import * as z from "zod";

export type StreamingProfileUpdate = {
  display_name?: string | null | undefined;
  representations: string;
};

export const StreamingProfileUpdate$zodSchema: z.ZodType<
  StreamingProfileUpdate
> = z.object({
  display_name: z.string().nullable().optional().describe(
    "The display name of the streaming profile",
  ),
  representations: z.string().describe(
    "A JSON string containing the list of representations with transformation parameters as strings",
  ),
});
